import React, { useRef } from 'react';
import Camera, { IMAGE_TYPES, FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { useFetch } from 'use-http';
import { useParams, useNavigate } from 'react-router-dom';
import { StatusEnum } from 'types/banners';
import classes from 'components/Layout/styles.module.scss';
import { imagebase64 } from 'utils/imagebase64';
import useLocalStorage from 'use-local-storage';
import { IStore } from 'dto/store.dto';
import { getFileBase64 } from 'utils/helpers';

const ALLOWED_STORES_FOR_INPUT_LOADING = process.env.REACT_APP_ALLOWED_STORES_FOR_GALLERY?.split(',').map(s => s.trim()) || [];

function dataURItoBlob(dataURI: any) {
	let byteString;
	if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
	else byteString = unescape(dataURI.split(',')[1]);

	const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	const ia = new Uint8Array(byteString.length);
	for (let i = 0; i < byteString.length; i += 1) {
		ia[i] = byteString.charCodeAt(i);
	}

	return new Blob([ia], { type: mimeString });
}

function generateIdempotencyKey(): string {
	const timestamp = Date.now();
	const randomBytes = new Uint8Array(16);
	crypto.getRandomValues(randomBytes);
	const randomPart = Array.from(randomBytes, byte => byte.toString(36)).join('').slice(0, 16);
	return `banner_${timestamp}_${randomPart}`;
}

function Photo() {

	const uploadInputRef = useRef<HTMLInputElement>(null);
	// TODO refact
	const [store] = useLocalStorage<IStore | undefined>(`store`, undefined);
	const { passportId, placeId } = useParams();
	const { get, post } = useFetch();

	const navigate = useNavigate();

	const [image, setImage] = React.useState<string | undefined>();
	const [place, setPlace] = React.useState<any>(null);
	const [passport, setPassport] = React.useState<any>({});
	const [banner, setBanner] = React.useState<any>(null);
	const [isDeviceGalleryImage, setDeviceGalleryImage] = React.useState<boolean>(false);
	const [idempotencyKey, setIdempotencyKey] = React.useState<string>('');

	async function load() {
		const place = await get(`/api/places/${placeId}`);
		setPlace(place);
		const result = await get(`/api/passport/${passportId}`);
		setPassport(result);
		if (place?.id) {
			const bannerList = await get(`/api/banners?passportId=${passportId}&placeId=${place?.id}`);
			if (bannerList?.rows?.length > 0) {
				setBanner(bannerList?.rows[0]);
			}
		}
	}

	React.useEffect(() => {
		if (placeId) {
			load();
		}
	}, [placeId]);

	function handleTakePhoto(dataUri: any) {
		setDeviceGalleryImage(false);
		setImage(dataUri);
		setIdempotencyKey(generateIdempotencyKey());
	}

	const saveInput = async () => {
		const element = uploadInputRef.current;
		if (!element) return alert('Произошла непредвиденная ошибка');

		const file = element.files?.[0];
		if (!file) return alert('Выберите фото перед отправкой');
		
		const bs64 = await getFileBase64(file);
		setDeviceGalleryImage(true);
		setImage(bs64);
		setIdempotencyKey(generateIdempotencyKey());
	};

	const handleSave = async (posted: boolean) => {
		try {
			if (!store?.id) {
				alert('Магазин не определен');
				return;
			}

			const file = dataURItoBlob(image);
			const body = new FormData();
			body.append('file', file, 'image.jpg');

			// Шаг 1: Загрузка файла
			const imageRes = await post('api/file/download', body);

			if (!imageRes || imageRes.statusCode || imageRes.error || !imageRes.id) {
				console.error('Ошибка при загрузке файла:', imageRes);
				alert('Ошибка при загрузке файла. Попробуйте еще раз.');
				return;
			}

			// Шаг 2: Обработка EXIF
			const exifRes = await post('api/banners/exif', {
				passportId,
				storeId: store.id,
				fileId: imageRes.id,
				isDeviceGallery: isDeviceGalleryImage,
			});

			if (!exifRes || exifRes.statusCode || exifRes.error || !exifRes.fileId) {
				console.error('Ошибка при обработке EXIF:', exifRes);
				alert('Ошибка при обработке фото. Попробуйте еще раз.');
				return;
			}

			// Шаг 3: Создание/обновление баннера
			const data = {
				...exifRes,
				passportId,
				posted,
				placeId: place?.id,
				isDeviceGallery: isDeviceGalleryImage,
				status: StatusEnum.pending,
				statusMrkt: StatusEnum.pending,
				statusAccnt: place.typeAllocation === 'free' ? StatusEnum.accept : StatusEnum.pending,
				idempotencyKey,
			};

			const bannerRes = await post(`/api/banners/upsert`, data);

			if (!bannerRes || bannerRes.statusCode || bannerRes.error) {
				console.error('Ошибка при создании баннера:', bannerRes);
				alert('Ошибка при сохранении баннера. Попробуйте еще раз.');
				return;
			}

			navigate(`/places?placementAt=${passport.placementAt}`);
		} catch (error) {
			console.error('Непредвиденная ошибка при сохранении:', error);
			alert('Произошла ошибка. Попробуйте еще раз.');
		}
	};

	return (
		<div>			
			{image ? (
				<div>
					<div className={classes.main}>
						<div className={classes.confirm}>
							<div className={classes['confirm__pic']}>
								<img alt="img" src={image} style={{ width: 'auto' }} />
							</div>
							<p style={{ color: 'red', padding: '0 15px', fontSize: '14px', fontWeight: 'bold', textAlign: 'justify', textAlignLast: 'center' }}>
								Перед сохранением фото рекламы убедитесь, что реклама читаема. При нечитаемой рекламе фотоотчет может быть отклонен
							</p>
							<div className={classes['confirm__row']}>
								<button
									onClick={() => handleSave(false)}
									className={`${classes.btn} ${classes.btn} ${classes['btn--attention']}`}
								>
									Реклама Familia <br />
									ОТСУТСТВУЕТ
								</button>
								<button
									onClick={() => handleSave(true)}
									className={`${classes.btn} ${classes.btn} ${classes['btn--primery']}`}
								>
									Реклама Familia <br /> В НАЛИЧИИ
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				<div>
					<div className={classes.main}>
						<Camera
							imageType={IMAGE_TYPES.JPG}
							isImageMirror={false}
							idealFacingMode={FACING_MODES.ENVIRONMENT}
							onTakePhoto={(dataUri: any) => {
								handleTakePhoto(dataUri);
							}}
						/>
						<p style={{ color: 'red', padding: '0 15px', fontSize: '14px', fontWeight: 'bold', textAlign: 'justify', textAlignLast: 'center' }}>
							Перед сохранением фото рекламы убедитесь, что реклама читаема. При нечитаемой рекламе фотоотчет может быть отклонен
						</p>
					</div>
					{ALLOWED_STORES_FOR_INPUT_LOADING.includes(store?.number || '-1') && (
						<div className={classes.chose_photo_container}>
							<input type="file" ref={uploadInputRef} accept="image/*" />
							<button className={`${classes.btn} ${classes.btn} ${classes['btn--primery']}`} onClick={saveInput}>
								Отправить
							</button>
						</div>
					)}
					{banner && (
						<div className={classes.main}>
							{banner.statusAccnt === StatusEnum.reject && (
								<div className={`${classes['photolocations-message']}`}>{banner.commentAccnt}</div>
							)}
							{banner.statusMrkt === StatusEnum.reject && (
								<div className={`${classes['photolocations-message']} `}>{banner.commentMrkt}</div>
							)}
						</div>
					)}
				</div>
		)}
		<h3 style={{ textAlign: 'center' }}>Пример фото</h3>
		<footer className={classes.footer}>
				{place?.['preview.uri'] && <img alt="img" src={place['preview.uri']} style={{ width: '100%' }} />}
			</footer>
		</div>
	);
}

export default Photo;
